import { useMemo } from 'react';
import { ZIP_CODE_SEARCH_URL } from '../../constants/constants';
import { handleRequestError, useRestClient } from './useRestClient';
import { AppError } from '@/utils/AppError';

type CityStateInfo = {
  city: string;
  state: string;
};

export function useGetCityByZip() {
  const { restClient } = useRestClient();

  const getCityByZipCode = async (zip: string): Promise<CityStateInfo> => {
    try {
      const response = await restClient.get(`${ZIP_CODE_SEARCH_URL}/${zip}`);
      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const item = data[0];

        if (item.city && item.state) {
          return item;
        }
      }

      throw { message: 'City not found in the response' } as AppError;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  return useMemo(
    () => ({
      getCityByZipCode,
    }),
    []
  );
}
